import { render } from "./CampaignsEmpty.vue?vue&type=template&id=8ba8af90&scoped=true"
const script = {}

import "./CampaignsEmpty.vue?vue&type=style&index=0&id=8ba8af90&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba8af90"]])

export default __exports__